import { gql } from 'urql';

export const getEventAttendeeEconRestriction = gql`
  query GetEventAttendeeEconRestriction($eventId: Int!, $playerId: Int!, $characterId: Int!) {
    event(eventId: $eventId) {
      id
      startsAt
      eventAttendee(playerId: $playerId) {
        id
        econMindExpenditure(characterId: $characterId)
        econResolveExpenditure(characterId: $characterId)
        econTimeExpenditureInMinutes
        user {
          id
          character(characterId: $characterId) {
            id
            currentMind
            currentResolve
            mindPenalty
          }
        }
      }
    }
  }
`;

export const getEventAttendee = gql`
  query GetEventAttendee($eventId: Int!, $playerId: Int!) {
    event(eventId: $eventId) {
      id
      registrationOpensAt
      startsAt
      endsAt
      description
      activeMembership(playerId: $playerId)
      maximumCheckinableCharacters(playerId: $playerId)
      isHomeGame(playerId: $playerId)
      canSelfCheckin(playerId: $playerId)
      activeCorrectiveActions(playerId: $playerId) {
        id
        issuer {
          id
          fullName
        }
        branch {
          id
          shorthand
        }
        kind
        reason
      }
      config {
        baseBuild
        maxExtraXp
        extraXpCost
        shiftUnit
        shiftMultiplier
        shiftKinds
      }
      eventAttendee(playerId: $playerId) {
        id
        buildAwarded
        buildGrowth
        checkinApproved
        kind
        paid
        attending
        restrictedMailout
        user {
          id
        }
        shifts {
          id
          label
        }
        ticket {
          id
          cost
          identifier
          label
          passType
          shiftResponsibilities
          modMaxSignup
        }
        attendeeCharacters {
          id
          printRequestStatus
          character {
            id
            name
            status
          }
        }
      }
      tickets(playerId: $playerId) {
        id
        cost
        discountType
        fullyBooked
        identifier
        label
        passType
        restrictionType
        shiftResponsibilities
        modMaxSignup
      }
      shifts {
        id
        label
        kind
        identifier
        isEnabled
        isFullyBooked
      }
    }
  }
`;

export const getEventAttendeeCharacterActionLogs = gql`
  query GetEventAttendeeCharacterActionLogs($eventId: Int!, $playerId: Int!) {
    event(eventId: $eventId) {
      id
      eventAttendee(playerId: $playerId) {
        id
        attendeeCharacters {
          id
          character {
            id
            name
            currentBody
            currentMind
            currentResolve
            skills {
              id
              characterSkillId
              level
            }
          }
          actionLogs {
            id
            valid
            log {
              id
              actionType
              actionValue
              description
              createdAt
              invalidatedAt
              mod {
                id
                name
              }
            }
            tally {
              armor
              body
              mind
              resolve
              skillUses {
                id
                characterSkillId
                remainingUses
                level
              }
            }
          }
        }
      }
    }
  }
`;

export const getEventAttendeeTransactionsTally = gql`
  query GetEventAttendeeTransactionsTally($eventId: Int!, $playerId: Int!) {
    event(eventId: $eventId) {
      id
      eventAttendee(playerId: $playerId) {
        id
        itemTransactionsTally {
          itemId
          itemName
          itemKind
          groupLimit
          limit
          claims {
            characterId
            status
            stack
          }
          statusClaims {
            characterId
            status
            stack
          }
          subtotal
          children {
            itemId
            itemName
            itemKind
            claims {
              characterId
              status
              stack
            }
          }
        }
      }
    }
  }
`;
